import React from "react";
import { Download, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { mediaUrl } from "@/lib/utils";

export function QRDisplay({ qrUrl, publicUrl, internalCode, downloadName = "qr-code.png" }) {
    const src = mediaUrl(qrUrl);

    async function download() {
        try {
            const res = await fetch(src, { credentials: "omit" });
            const blob = await res.blob();
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = downloadName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        } catch {
            // fallback: open in new tab
            window.open(src, "_blank", "noopener");
        }
    }

    return (
        <Card className="rounded-xl border shadow-sm" data-testid="asset-qr-panel">
            <CardContent className="flex flex-col items-center gap-3 p-5">
                <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                    QR Code
                </div>
                <div className="rounded-xl bg-white p-3 shadow-sm">
                    {src ? (
                        <img src={src} alt={`QR ${internalCode || ""}`} className="h-56 w-56 object-contain" data-testid="asset-qr-image" />
                    ) : (
                        <div className="grid h-56 w-56 place-items-center text-xs text-muted-foreground">
                            QR indisponível
                        </div>
                    )}
                </div>
                {publicUrl && (
                    <div className="break-all text-center text-[11px] text-muted-foreground">
                        {publicUrl}
                    </div>
                )}
                <div className="flex w-full flex-col gap-2 sm:flex-row">
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={download}
                        className="flex-1"
                        data-testid="asset-qr-download-button"
                        disabled={!src}
                    >
                        <Download className="mr-2 h-4 w-4" /> Baixar QR
                    </Button>
                    {publicUrl && (
                        <Button
                            variant="ghost"
                            size="sm"
                            asChild
                            className="flex-1"
                            data-testid="asset-public-page-open-button"
                        >
                            <a href={publicUrl} target="_blank" rel="noopener noreferrer">
                                <ExternalLink className="mr-2 h-4 w-4" /> Página pública
                            </a>
                        </Button>
                    )}
                </div>
            </CardContent>
        </Card>
    );
}
